import * as messages from './common/messages';
import * as storageKeys from './storageKeys';

const resolveUserAndTeamIdentifiers = ({
  deviceId,
  utk,
  email,
  hubId
}, {
  allowUnauthed,
  isExternalHost
}) => {
  let anon;
  let user;
  let team;

  if (hubId) {
    team = hubId;
  }

  if (email) {
    user = `EMAIL:::${email}:::${storageKeys.accountId}`;
  } else if (utk) {
    if (isExternalHost) {
      anon = `TEMP_ID:::${utk}:::${storageKeys.accountId}`;
    } else {
      anon = `VISITOR:::${utk}:::${storageKeys.accountId}`;
    }
  } else if (deviceId) {
    anon = `TEMP_ID:::${deviceId}:::${storageKeys.accountId}`;
  }

  if (!anon && !user) {
    throw messages.eventError('Could not identify user. Please specify either an email address or __hstc cookie identifer.');
  }

  if (!allowUnauthed) {
    if (!user) {
      throw messages.eventError('Could not identify user. Please specify an email address.');
    }

    if (!team) {
      throw messages.eventError('Could not identify hub. Please specify a hubId.');
    }
  }

  return {
    user: user || anon,
    team
  };
};

const parseUtk = hstc => {
  let utk;

  if (hstc) {
    const hstcParts = hstc.split('.');

    if (hstcParts.length > 1) {
      utk = hstcParts[1];
    }
  }

  return utk;
};

export const createIdentifiers = ({
  email,
  userId,
  hubId,
  hstc,
  deviceId
}, {
  allowUnauthed,
  isExternalHost
}) => {
  const utk = parseUtk(hstc);
  const {
    user,
    team
  } = resolveUserAndTeamIdentifiers({
    deviceId,
    utk,
    email,
    hubId
  }, {
    allowUnauthed,
    isExternalHost
  });
  return {
    user,
    team,
    utk,
    raw: {
      email,
      userId,
      hubId,
      hstc,
      deviceId
    }
  };
};